import React from 'react';

// The row finds these by class rather than by ref: the name components take a
// className but forward no ref, and the time figures have to stay measurable
// while the verdict on them is being made.
export const META_NAME_CLASS = 'cardMeta__name';
export const META_AGE_CLASS = 'cardMeta__age';
export const META_DURATION_CLASS = 'cardMeta__duration';

// The age goes first and the duration second, so `data-crowded` is how many of
// them the row has given up.
const CROWD_STEPS = 2;

/**
 * Sheds the time figures, one at a time, until the credit no longer has to be
 * truncated to fit beside them — a long author name is worth more than the
 * age. Each pass starts from nothing shed, so the answer never depends on the
 * answer before it, and reports through `data-crowded` on the row.
 *
 * `signature` is everything on the row that takes width: a resize is not the
 * only way the credit loses its room.
 */
export default function useMetaFit(signature) {
  const rowRef = React.useRef(null);
  const [crowdLevel, setCrowdLevel] = React.useState(0);

  React.useLayoutEffect(() => {
    const row = rowRef.current;
    if (!row) return undefined;
    const decide = () => {
      const name = row.querySelector(`.${META_NAME_CLASS}`);
      if (!name) return;
      let level = 0;
      row.dataset.crowded = '0';
      while (level < CROWD_STEPS && name.scrollWidth > name.clientWidth + 1) {
        level += 1;
        row.dataset.crowded = String(level);
      }
      setCrowdLevel(level);
    };
    decide();
    const observer = new ResizeObserver(decide);
    observer.observe(row);
    return () => observer.disconnect();
  }, [signature]);

  return { rowRef, crowdLevel };
}
